import {useEffect,useRef,useState} from 'react';
import type {Snapshot} from '@platform/contracts/x';
import {useCopy,useUi} from '@platform/ui/config';

export function PurchasePrizeGuide({state}:{state:Snapshot}){
 return <RotatingPrizeGuide key={state.drawId} state={state}/>;
}

function RotatingPrizeGuide({state}:{state:Snapshot}){
 const t=useCopy(),ui=useUi(),ref=useRef<HTMLElement>(null);
 const [active,setActive]=useState(0),[hover,setHover]=useState(false),[focused,setFocused]=useState(false);
 const [visible,setVisible]=useState(true),[hidden,setHidden]=useState(document.hidden);
 const slides=[...state.prizes.filter(p=>p.id!=='jackpot').map(prize=>{
  const stage=t('prize.'+prize.id),multiplier=prize.multiplier?.toLocaleString(ui.controls.prizeDisplayLocale)??'';
  return {id:prize.id,value:'×'+multiplier,title:t('x.guideStageTitle',{stage}),lead:t('x.guideStageLead'),emphasis:t('x.guideStageWin')};
 }),{id:'jackpot',value:t('x.guideJackpotMark'),title:t('x.guideJackpotLead',{count:state.x.jackpotBallLimit}),lead:t('x.guideJackpotAction'),emphasis:t('x.guideJackpotWin')}];
 useEffect(()=>{
  const visibility=()=>setHidden(document.hidden);
  const observer=new IntersectionObserver(([entry])=>setVisible(entry.isIntersecting));
  if(ref.current)observer.observe(ref.current);
  document.addEventListener('visibilitychange',visibility);
  return()=>{observer.disconnect();document.removeEventListener('visibilitychange',visibility);};
 },[]);
 useEffect(()=>{
  if(hover||focused||hidden||!visible)return;
  const timer=window.setTimeout(()=>setActive(index=>(index+1)%slides.length),ui.controls.prizeGuideIntervalMilliseconds);
  return()=>window.clearTimeout(timer);
 },[active,hover,focused,hidden,visible,slides.length,ui.controls.prizeGuideIntervalMilliseconds]);
 return <section ref={ref} className="purchase-prize-guide" aria-label={t('x.purchaseGuide')} data-stage={slides[active].id} tabIndex={0}
  onKeyDown={event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();setActive(index=>(index+(event.key==='ArrowRight'?1:slides.length-1))%slides.length);}}}
  onPointerEnter={event=>{if(event.pointerType==='mouse')setHover(true);}} onPointerLeave={()=>setHover(false)}
  onFocusCapture={()=>setFocused(true)} onBlurCapture={event=>{if(!event.currentTarget.contains(event.relatedTarget))setFocused(false);}}>
  <div className="purchase-prize-message" aria-live="off">{slides.map((slide,index)=><p key={slide.id} data-prize={slide.id} data-active={index===active} aria-hidden={index!==active}><span className="purchase-prize-copy"><span className="purchase-prize-title">{slide.title}</span><span className="purchase-prize-lead">{slide.lead}</span></span><strong className="purchase-prize-win"><b>{slide.value}</b>{' '}<span>{slide.emphasis}</span></strong></p>)}</div>
 </section>;
}
